module.exports = __webpack_public_path__ + "img/ColoredSpace1.992e3e94.jpg";